// extracted by mini-css-extract-plugin
module.exports = {"documents":"DocumentList_documents__3jj6U","documentList":"DocumentList_documentList__3mXFf"};